import _ from 'lodash'
import Vuex from 'vuex'
import M from 'moment'
import helpers from '../../helpers'

const getImagePath = helpers('getImagePath')
const formatString = helpers('formatString')

_.mixin({
    dt: M,
    imgPath: getImagePath,
    str: formatString,
});

const api = helpers('api')

export default {
    computed: {
        _() {
            return _
        },

        api() {
            return api
        },

        helpers() {
            return helpers
        },
    },

    methods: {
        ...Vuex.mapActions('notification', {
            notification_push: 'push',
         }),

        __(value, format = null) {
            return formatString(value, format)
        },

        getToken() {
            return _.get(this.user, 'content.token')
        },

        setToken(token) {
            if (token) {
                this.api.setHeader('authorization', `bearer ${token}`)
            }
        },

        randomKey() {
            return Math.floor(Math.random() * 1000000)
        },

        serialize(value) {
            return JSON.stringify(value)
        },

        goto(url) {
            window.open(url, '_blank')
        },

        imgPath() {
            let path = _.imgPath.apply(this, arguments)
            let env = helpers('env')
            return env.rootPath + path
        },

        alert(message) {
            this.$ons.notification.alert(message, {
                title: '',
            })
        },

        doNothing(e) {
            if (e) {
                e.preventDefault();
            }
        },

        isIOS() {
            return this.$ons.platform.isIOS(true);
        },

        isAndroid() {
            return this.$ons.platform.isAndroid(true);
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Utils.js